import { render } from "./Renja.vue?vue&type=template&id=9335508c"
import script from "./Renja.vue?vue&type=script&lang=js"
export * from "./Renja.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__